import { UntilDestroy } from '@ngneat/until-destroy';
import { inject, Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  ResolveFn
} from '@angular/router';
import { Observable } from 'rxjs';
import { AudienceBuilderService } from '../audience-builder/audience-builder.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
class LookalikeModelResolverService {
  constructor(
    public builderService: AudienceBuilderService,
    public route: ActivatedRoute
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const audienceId = route.params['audienceId'];
    const contextId = route.params['contextId'];
    return this.builderService.fetchAudienceLookalikeDetails(
      audienceId,
      contextId
    );
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LookalikeModelResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot
): Observable<any> => {
  return inject(LookalikeModelResolverService).resolve(route);
};
